<template>
    <v-flex xs-12 sm8 offset-sm2 text-xs-center>
      <h3 class="display-1 font-weight-bold mb-3">
        Predict AAT
      </h3>
      <h3>Friedrich Kueppers, M.D.</h3>
    </v-flex>
</template>

<script>
  export default {
    data: () => ({
    })
  }
</script>

<style>

</style>
